"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidJsonPointerRefError = void 0;
var json_pointer_1 = __importDefault(require("@json-schema-spec/json-pointer"));
/**
 * Error thrown when a JSON pointer is provided but is not parseable as per the RFC6901
 *
 */
var InvalidJsonPointerRefError = /** @class */ (function () {
    function InvalidJsonPointerRefError(ref, additionalMsg) {
        this.name = "InvalidJsonPointerRefError";
        this.message = [
            "InvalidJsonPointerRefError",
            "The provided RFC6901 JSON Pointer is invalid: ".concat(ref),
            "",
            "addition info: ",
            additionalMsg,
        ].join("\n");
    }
    return InvalidJsonPointerRefError;
}());
exports.InvalidJsonPointerRefError = InvalidJsonPointerRefError;
exports.default = (function (ref, root) {
    try {
        var withoutHash = ref.replace("#", "");
        var pointer = json_pointer_1.default.parse(withoutHash);
        return pointer.eval(root);
    }
    catch (e) {
        throw new InvalidJsonPointerRefError(ref, e.message);
    }
});
